import { defineComponent as _defineComponent } from 'vue'
import { BaseIcon } from '@warrenbrasil/nebraska-web';

type ContextBannerType = 'alert' | 'info' | 'negative' | 'success';

interface Props {
  title: string;
  type: ContextBannerType;
  icon?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContextBanner',
  props: {
    title: null,
    type: null,
    icon: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  type: ContextBannerType;
  icon?: string;
};




return { __sfc: true,props, BaseIcon }
}

})